/**
 * Query keys for Bundle API hooks
 *
 * Centralized query keys enable consistent cache invalidation across all bundle hooks.
 */

export const bundleQueryKeys = {
  all: ['cruise-bundles'] as const,
  lists: () => [...bundleQueryKeys.all, 'list'] as const,
  list: (params: { page: number }) => [...bundleQueryKeys.lists(), params] as const,
  details: () => [...bundleQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...bundleQueryKeys.details(), id] as const,
  items: (bundleId: string) => [...bundleQueryKeys.all, 'items', bundleId] as const,
  options: (bundleId: string, itemId: string) => [...bundleQueryKeys.all, 'options', bundleId, itemId] as const,
  filters: (bundleId: string) => [...bundleQueryKeys.all, 'filters', bundleId] as const,
};
